console.log('🎬 DÉMARRAGE animations rôtisserie...');

// Animations scroll reveal pour la section Hero
function initScrollReveal() {
  console.log('🎬 Section Hero détectée, application des animations...');
  
  // Sélection des éléments Hero avec plusieurs sélecteurs pour plus de compatibilité
  const heroElements = document.querySelectorAll('.section--hero h1, .section--hero h2, .section--hero p, .section--hero .btn, .hero h1, .hero h2, .hero p, .hero .btn, [data-section-type="hero"] h1, [data-section-type="hero"] h2, [data-section-type="hero"] p, [data-section-type="hero"] .btn');
  
  if (heroElements.length === 0) {
    console.log('❌ Aucun élément Hero trouvé avec les sélecteurs standards');
    // Fallback: chercher dans toute section qui pourrait être un hero
    const fallbackElements = document.querySelectorAll('section h1, section h2, section .btn');
    console.log(`📝 ${fallbackElements.length} éléments trouvés en fallback`);
    
    fallbackElements.forEach((el, index) => {
      if (index < 3) { // Limiter aux 3 premiers pour éviter de trop modifier
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
        
        setTimeout(() => {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          console.log(`🎬 DÉMARRAGE animation élément ${index + 1} maintenant !`);
        }, 700 + (index * 400));
      }
    });
    
    return;
  }
  
  console.log(`📝 ${heroElements.length} éléments trouvés pour animation`);
  
  // Application des animations avec délais progressifs
  heroElements.forEach((el, index) => {
    // État initial : invisible et décalé vers le bas
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
    
    // Animation avec délai progressif
    setTimeout(() => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
      console.log(`🎬 DÉMARRAGE animation H${index + 1} maintenant !`);
      
      // Log de progression
      setTimeout(() => {
        console.log(`📈 Progression animation ${index + 1}/3 - État: ${el.style.opacity}`);
      }, 200);
      
    }, 700 + (index * 400)); // 0.7s, 1.1s, 1.5s, etc.
  });
  
  // Observer pour détecter les changements
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('👁️ Élément Hero visible dans le viewport');
      }
    });
  });
  
  heroElements.forEach(el => {
    observer.observe(el);
  });
}

// Header simple avec détection scroll - DÉSACTIVÉ (conflit avec glassmorphism)
function initModernHeader() {
  console.log('⚠️ initModernHeader désactivé - utilise le glassmorphism du header-premium');
  // Cette fonction est désactivée car elle entre en conflit avec 
  // l'effet glassmorphism du header-premium custom
  return;
}

// Initialiser au chargement du DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
    initModernHeader();
  });
} else {
  initScrollReveal();
  initModernHeader();
}

// Réinitialiser lors des transitions de page (compatibility avec view transitions)
document.addEventListener('shopify:section:load', () => {
  initScrollReveal();
  initModernHeader();
});